module.exports = __webpack_public_path__ + "static/black_dragon_wyrmling-e5b0738d024297a59481a58d5809767b.jpg";